import LayoutRewardsBazaar from 'components/Content/ContentLayout/LayoutRewardsBazaar/LayoutRewardsBazaar';
import { withLayoutRewardsBazaarProps } from 'viewModel/content/layoutRewardsBazaar/withLayoutRewardsBazaarProps';

export default withLayoutRewardsBazaarProps(LayoutRewardsBazaar);
